<template>
      <div class="box box--white ssv-order__participant-item">
          <h4>
              Účastník {{index + 1}}
              <button class="button button--link" v-if="(index + 1) === numberOfParticipants && index !== 0" v-on:click="decreaseParticipant">odebrat</button>
          </h4>
          <ssv-order-participant-form :distributors="distributors" :shirt-available="shirtAvailable" :index="index"/>
      </div>
</template>
<script>
    import {mapActions, mapGetters} from 'vuex';
    import SsvOrderParticipantForm from './ParticipantForm';

    export default {
        name: 'SsvOrderParticipantItem',
        components: {
            SsvOrderParticipantForm
        },
        props: {
            index: Number,
            shirtAvailable: {
                type:    Boolean,
                require: false,
                default: () => false,
            },
            distributors:   {
                type:    Boolean,
                require: false,
                default: () => false,
            },
        },
        computed: {
            ...mapGetters('ssvOrder', ['numberOfParticipants']),
        },
        methods: {
            ...mapActions('ssvOrder', ['decreaseParticipant']),
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/ssv-order/participant/ParticipantItem.vue